<template>
    <div>
        <a class="title-link text-bold" :href="'#' + link">{{initialValue}}</a>
        <p class="small-link text-bold">{{path}}
            <template v-if="redirect"> &#8594; {{redirect}}</template>
        </p>
    </div>
</template>
<script>
import Vue from 'vue';

export default {
    data() {
        return {

        }
    },

    components: {

    },

    props: ['initialValue', 'css', 'data', 'references'],

    computed: {
        link() {
            return this.helpers('uriFormat')(_.get(this.data, 'link', ''));
        },
        redirect() {
            const { content_type, redirect_url } = this.data;
            if (content_type != 'redirect') return null;
            return redirect_url;
        },
        path() {
            return '/' + _.get(this.data, 'path', '');
        },
    },

    mounted() {

    },

    methods: {

    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/table-elements/PageTitleComponent.vue